// extracted by mini-css-extract-plugin
export default {"openButton":"HI-z","modalContent":"II-z","hideOutsideOfMobile":"JI-z"};